import bridge from "@vkontakte/vk-bridge"
import axios from "axios"
import { PostcardActionsEventT } from "src/entity/Analitic"
import { INominationsResponce, PostVoteT } from "src/entity/Pretendents"
import { IPostSecondStageVotes } from "src/features/postSecondStageVotes"

export const MAIN_URL = "https://www.karusel-tv.ru/glavgeroi-app-2025"
export const POST_POSTCARD_URL = "https://gg2023.karusel-tv.ru/image.php"
export const ANALITIC_API = "event-tracking.json"
export const VK_WALL_UPLOAD_URL = "vk-wall-upload.json"
export const GET_SECOND_STAGE_PRETENDENTS = "nominants.json"
export const SEND_FIRST_STAGE_VOICES_EP = "/posts"
export const SEND_SEC_STAGE_VOICES_EP = "/posts"
export const GET_NOMINATIONS = "nominations.json"
export const POST_FIRSTSTAGE_VOTES = "voting.json"
export const POST_SECONDSTAGE_VOTES = "vote.json"
export const GET_PREDICTS = "predicts.json"

export const api = {
  getNominations: async () => {
    try {
      // const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_NOMINATIONS}`)
      const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_PREDICTS}`)
      // const { data } = await axios.get<INominationsResponce[]>(`http://localhost:10888/nominations_2025_mock.json`)

      return data
    } catch (error) {
      throw new Error("Произошла ошибка, попробуйте немного позже")
    }
  },
  getSecondStagePretendents: async () => {
    try {
      // const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_SECOND_STAGE_PRETENDENTS}`)
      const { data } = await axios.get<INominationsResponce[]>(`${MAIN_URL}/${GET_PREDICTS}`)
      // const { data } = await axios.get<INominationsResponce[]>(`http://localhost:10888/nominants_2025_mock.json`)
      return data
    } catch (error) {
      throw new Error("Произошла ошибка, попробуйте немного позже")
    }
  },

  postFirstStageVotes: (firstStageVotes: PostVoteT) => axios.post(`${MAIN_URL}/${POST_FIRSTSTAGE_VOTES}`, firstStageVotes),
  postPostCard: (form: FormData) => axios.post(`${POST_POSTCARD_URL}`, form),
  sendPostCardActionEvent: async (type: PostcardActionsEventT) => {
    try {
      const { data } = await axios.get(`${MAIN_URL}/${ANALITIC_API}?type=${type}`)
      if (!data.success) {
        throw new Error("Произошла ошибка, попробуйте немного позже")
      }
    } catch (error) {
      throw new Error(String(error))
    }
  },
  postSharePostCardData: async (form: FormData) => {
    try {
      const { data } = await axios.post(`${MAIN_URL}/${VK_WALL_UPLOAD_URL}`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      return data
    } catch (error) {
      throw new Error(String(error))
    }
  },
  postSecondStageVotes: async (secondStageVotes: IPostSecondStageVotes) => {
    try {
      const { data } = await axios.post(`${MAIN_URL}/${POST_SECONDSTAGE_VOTES}`, secondStageVotes)
      if (!data.success) {
        throw new Error("Произошла ошибка, попробуйте немного позже")
      }
    } catch (error) {
      throw new Error(String(error))
    }
  },
}
